import api from '../api';

import { ParamsBodyEditCustomerAppPhone } from 'utils/typeServices';

export const PostEditCustomerAppPhone = async ({ token, body }: { token: string, body: ParamsBodyEditCustomerAppPhone }) => {
    const bodyJson = JSON.stringify(body);

    try {
        const { data } = await api.post<{ Data: any }>('v1/Cliente/EditCustomerAppPhone', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
